import { ListStyle } from '@yleisradio/areena-types';

export const isHeroList = (listStyle: ListStyle | undefined): boolean =>
  listStyle?.size === 'extra-large';

export const isGridList = (listStyle: ListStyle | undefined): boolean =>
  listStyle?.layout === 'grid';

export const isPosterList = (listStyle: ListStyle | undefined): boolean =>
  listStyle?.image === '9:13';

export const isSquareList = (listStyle: ListStyle | undefined): boolean =>
  listStyle?.image === '1:1';
